package br.com.vvrefeicoes.portal.domain.model

import org.jetbrains.compose.resources.StringResource

data class MonthlyCost(
    val period: MonthPeriod,
    val costCents: Long,
    val revenueCents: Long,
) {
    val costShareOfRevenuePercent: Double
        get() = if (revenueCents == 0L) 0.0 else costCents.toDouble() / revenueCents * 100
}

data class CostCategoryCost(
    val categoryId: String,
    val title: StringResource,
    val monthlyCents: List<Long>,
) {
    val totalCents: Long
        get() = monthlyCents.sum()
}

data class CostsSnapshot(
    val period: MonthPeriod,
    val totalCents: Long,
    val fopagCents: Long,
    val operationalCents: Long,
    val revenueCents: Long,
    val headcount: Int,
    val monthly: List<MonthlyCost>,
    val months: List<MonthPeriod>,
    val categories: List<CostCategoryCost>,
) {
    val fopagPerEmployeeCents: Long
        get() = if (headcount == 0) 0L else fopagCents / headcount

    val categoriesTotalCents: Long
        get() = categories.sumOf { it.totalCents }

    companion object {
        fun empty(period: MonthPeriod): CostsSnapshot =
            CostsSnapshot(
                period = period,
                totalCents = 0L,
                fopagCents = 0L,
                operationalCents = 0L,
                revenueCents = 0L,
                headcount = 0,
                monthly = emptyList(),
                months = emptyList(),
                categories = emptyList(),
            )
    }
}
